import { serverUri } from "@helpers/_constants";

var uri;
uri = serverUri;
export default uri;
